let storage: Storage = {}

/**
 * Cache is responsible for an information user might already have.
 * For instance, it stores countries if user already requested it from the server.
 */
export default {
    storage: function () {
        return storage
    },
    get: function (key) {
        if (!key) return null
        return storage[key] ? storage[key] : null 
    },
    add: function (key, item) {
        storage = { ...storage, [key]: item }
    },
    update: function (key, update) {
        const newItem = update(this.get(key))
        this.add(key, newItem)
    },
    ageless: function (key) {
        if (!key) return false
        return key.startsWith('ageless.')
    },
    agelessExists: function (key) {
        return Boolean(this.ageless(key) && this.get(key))
    }
} as Cache

interface Cache {
    storage(): Storage
    get(key: string | undefined): any
    add(key: string, item: any): void
    update(key: string, update: (item: any) => void): void
    ageless(key: string | undefined): boolean
    agelessExists(key: string | undefined): boolean
}

interface Storage {
    [key: string]: any
}